import { z } from 'zod';
import { ANALYSIS_ITEM_IDS, DEFAULT_REPORT_ID, IN_HOUSE_REPORT_IDS, STATUTORY_REPORT_IDS } from './-constants';
const reportMenuIdSchema = z.enum(STATUTORY_REPORT_IDS).or(z.enum(IN_HOUSE_REPORT_IDS)).or(z.enum(ANALYSIS_ITEM_IDS));
export const ReportsSearchSchema = z.object({
  freeText: z.string().default(''),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(50),
  /** 表示中の帳票 / 分析。未知の値は既定へフォールバックする */
  report: reportMenuIdSchema.catch(DEFAULT_REPORT_ID).default(DEFAULT_REPORT_ID)
});
export type ReportsSearchParams = z.infer<typeof ReportsSearchSchema>;